import { createSelector } from 'reselect';

import { getCoworkingAmenities } from '../dump/getCoworkingAmenities';

import { coworkingSelectedOfferSelector } from './coworkingSelectedOfferSelector';

export const getCoworkingOrOfferAmenitiesSelector = createSelector(
  [getCoworkingAmenities, coworkingSelectedOfferSelector],
  (coworkingAmenities, selectedOffer) => {
    if (selectedOffer) {
      return selectedOffer.amenities;
    }

    return coworkingAmenities;
  },
);
